module.exports = __webpack_public_path__ + "img/cloud-hail.825d5d48.svg";